// Collections live in content/ and are edited in DataTrek.
// Re-exported here so existing imports keep working.
import coreValuesData from "../content/core-values.json";
export const coreValues = coreValuesData;

export const missionStatement = {
  headline: "Our Mission",
  text: "To show Gilgit-Baltistan the way the people who live here know it — the lakes, the cold deserts, the forts and the high plateaus — run by a local team, at a pace that leaves room to stop and look.",
};
export const story = {
  headline: "Who We Are",
  paragraphs: [
    "D, Trio Trek is run by native Gilgit-Baltistan tour professionals. We are not a booking desk in another city arranging trips into a region from a distance — Skardu is home, and the valleys on these itineraries are the ones we grew up in.",
    "That is the whole difference. We know which road holds after rain and which does not, when Deosai opens and when the pass is still under snow, which guesthouse answers the phone in season, and where to stand at Thoqsikhar an hour before sunset. Every driver and guide is from here, and the fees stay here with them.",
    "Trips run privately, in our own 4x4s, and every itinerary bends around your flights and what you actually want to see. Give it a try.",
  ],
};
